import React from 'react';
import GoogleMapReact from 'google-map-react';
import {gmap} from '../gmap.js';

const Point = () => <div><img style={{width:'40px'}} src={require('../../img/pointer.png')}/></div>;
const Gmap = () =>{
	const mapOptions = {styles: gmap};
	return(
		<div className='gmap anime'>
			<GoogleMapReact
					bootstrapURLKeys={{
						key:'AIzaSyDQ4GYLtBmKG6Z5ZzqPkQLBeQ8jfv3i1pU'
					}}
					center={{
						lat: 50.4485405,
						lng: 30.4109287
					}}
					zoom={14}
					options={mapOptions}
				>
					<Point
						lat={50.4486005}
            			lng={30.4109187}
					/>
			</GoogleMapReact>
		</div>
	)}
export default Gmap;